import { ACCEPTANCE_CRITERIA_OPTION } from '@src/features/shift-post-v2/steps'

export const getSelectedAcceptanceCriteriaOption = (
  autoAcceptByRosters: boolean,
  autoAccept: boolean,
  hasAutoAcceptNowButShiftDidNot?: boolean,
) => {
  if (autoAcceptByRosters) {
    return ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS
  }

  if (autoAccept) {
    return ACCEPTANCE_CRITERIA_OPTION.VERIFIED
  }
  /**
   * The order is important here.
   * If the business entity has auto accept enabled, but the shift does not have auto accept enabled,
   * we should show the verified option.
   */
  if (hasAutoAcceptNowButShiftDidNot) {
    return ACCEPTANCE_CRITERIA_OPTION.VERIFIED
  }

  return ACCEPTANCE_CRITERIA_OPTION.PERSONALLY_APPROVED
}
